(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["architecture"] && !Shopify.designMode) return;
  try {
    
  class ArchitectureScrollPin extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-architecture-track]');
      this.viewport = this.querySelector('[data-architecture-viewport]');
      if (!this.track || !this.viewport) return;

      this.reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.mobileQuery = window.matchMedia('(max-width: 749px)');
      this.maxTranslate = 0;
      this.rafId = null;

      this.measure = this.measure.bind(this);
      this.onScroll = this.onScroll.bind(this);

      this.resizeObserver = new ResizeObserver(this.measure);
      this.resizeObserver.observe(this.track);
      this.resizeObserver.observe(this.viewport);

      this.reducedMotionQuery.addEventListener('change', this.measure);
      this.mobileQuery.addEventListener('change', this.measure);
      window.addEventListener('scroll', this.onScroll, { passive: true });

      this.measure();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
      this.reducedMotionQuery?.removeEventListener('change', this.measure);
      this.mobileQuery?.removeEventListener('change', this.measure);
      this.resizeObserver?.disconnect();
      if (this.rafId !== null) cancelAnimationFrame(this.rafId);
    }

    measure() {
      const allowed = !this.reducedMotionQuery.matches && !this.mobileQuery.matches;

      this.maxTranslate = allowed
        ? Math.max(0, this.track.scrollWidth - this.viewport.clientWidth)
        : 0;

      // Only pin when the track actually overflows. Pinning with zero travel
      // would steal a full viewport height of scrolling and move nothing.
      this.enabled = allowed && this.maxTranslate > 0;

      if (!this.enabled) {
        this.removeAttribute('data-pinned');
        this.style.height = '';
        this.track.style.transform = '';
        return;
      }

      this.setAttribute('data-pinned', '');
      this.style.height = `${this.viewport.offsetHeight + this.maxTranslate}px`;
      this.update();
    }

    onScroll() {
      if (this.rafId !== null) return;
      this.rafId = requestAnimationFrame(() => {
        this.rafId = null;
        this.update();
      });
    }

    update() {
      if (!this.enabled) return;

      const scrollable = this.offsetHeight - this.viewport.offsetHeight;
      if (scrollable <= 0) return;

      const rect = this.getBoundingClientRect();
      const progress = Math.min(1, Math.max(0, -rect.top / scrollable));

      this.track.style.transform = `translate3d(-${progress * this.maxTranslate}px, 0, 0)`;
    }
  }

  if (!customElements.get('architecture-scroll-pin')) {
    customElements.define('architecture-scroll-pin', ArchitectureScrollPin);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-reveal"] && !Shopify.designMode) return;
  try {
    
  class RevealOnScroll extends HTMLElement {
    connectedCallback() {
      const threshold = parseFloat(this.dataset.threshold || '0.3');
      const exitPoint = parseFloat(this.dataset.exitPoint || '30');
      this.replay = this.dataset.replay !== 'false';

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.classList.add('is-visible');
        return;
      }

      /*
        Watch the card row, not the whole section. The section also contains the
        tall backdrop image, so observing it means "out of view" only happens
        once that image has scrolled away too — long after the cards have gone.
      */
      this.target = this.querySelector('.product-reveal__cards') || this;

      this.observer = new IntersectionObserver(
        (entries) => {
          for (const entry of entries) {
            if (entry.isIntersecting) {
              this.classList.add('is-visible');
              if (!this.replay) this.observer.unobserve(entry.target);
            } else if (this.replay) {
              this.classList.remove('is-visible');
            }
          }
        },
        {
          threshold,
          /*
            Pull the detection band down from the top of the screen so the cards
            begin hiding as they leave the upper area, instead of lingering until
            they are fully gone.
          */
          rootMargin: `-${exitPoint}% 0px 0px 0px`,
        }
      );

      this.observer.observe(this.target);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }
  }

  if (!customElements.get('reveal-on-scroll')) {
    customElements.define('reveal-on-scroll', RevealOnScroll);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('reviews-scroller')) {
    customElements.define(
      'reviews-scroller',
      class extends HTMLElement {
        connectedCallback() {
          this.grid = this.querySelector('.reviews__grid');
          this.dots = this.querySelector('.reviews__dots');
          if (!this.grid || !this.dots) return;
          this.cards = [...this.grid.children];
          this.pageCount = 0;

          this.update = this.update.bind(this);
          this.grid.addEventListener('scroll', this.update, { passive: true });
          this.resizeObserver = new ResizeObserver(this.update);
          this.resizeObserver.observe(this.grid);

          this.dots.addEventListener('click', (event) => {
            const dot = event.target.closest('button');
            if (dot) this.goToPage(Number(dot.dataset.page));
          });

          this.setUpMouseDrag();
        }

        disconnectedCallback() {
          this.resizeObserver?.disconnect();
        }

        // Touch swiping is native; this adds the same click-and-drag swipe for mouse users.
        setUpMouseDrag() {
          let startX = 0;
          let startScroll = 0;
          let dragging = false;

          this.grid.addEventListener('pointerdown', (event) => {
            if (event.pointerType !== 'mouse' || event.button !== 0) return;
            dragging = true;
            startX = event.clientX;
            startScroll = this.grid.scrollLeft;
            this.grid.setPointerCapture(event.pointerId);
            this.grid.classList.add('is-dragging');
          });

          this.grid.addEventListener('pointermove', (event) => {
            if (!dragging) return;
            this.grid.scrollLeft = startScroll - (event.clientX - startX);
          });

          const end = () => {
            if (!dragging) return;
            dragging = false;
            this.grid.classList.remove('is-dragging');
            this.scrollToCard(Math.round(Math.abs(this.grid.scrollLeft) / this.cardStep));
          };
          this.grid.addEventListener('pointerup', end);
          this.grid.addEventListener('pointercancel', end);
        }

        get cardStep() {
          if (this.cards.length < 2) return this.grid.clientWidth || 1;
          return Math.abs(this.cards[1].offsetLeft - this.cards[0].offsetLeft) || 1;
        }

        get perView() {
          return Math.max(1, Math.round((this.grid.clientWidth + this.gap) / this.cardStep));
        }

        get gap() {
          return parseFloat(getComputedStyle(this.grid).columnGap) || 0;
        }

        scrollToCard(index) {
          const card = this.cards[Math.min(Math.max(index, 0), this.cards.length - 1)];
          if (!card) return;
          const direction = getComputedStyle(this.grid).direction === 'rtl' ? -1 : 1;
          this.grid.scrollTo({
            left: direction * Math.abs(card.offsetLeft - this.cards[0].offsetLeft),
            behavior: 'smooth',
          });
        }

        goToPage(page) {
          this.scrollToCard(page * this.perView);
        }

        update() {
          const max = this.grid.scrollWidth - this.grid.clientWidth;
          const pageCount = max > 1 ? Math.ceil(this.cards.length / this.perView) : 0;
          this.dots.hidden = pageCount < 2;

          if (pageCount !== this.pageCount) {
            this.pageCount = pageCount;
            this.dots.replaceChildren(
              ...Array.from({ length: pageCount }, (_, page) => {
                const dot = document.createElement('button');
                dot.type = 'button';
                dot.className = 'reviews__dot';
                dot.dataset.page = page;
                dot.setAttribute('aria-label', `Show reviews ${page + 1} of ${pageCount}`);
                return dot;
              })
            );
          }
          if (pageCount < 2) return;

          const scrolled = Math.abs(this.grid.scrollLeft);
          const active =
            scrolled >= max - 2
              ? pageCount - 1
              : Math.min(pageCount - 1, Math.round(scrolled / this.cardStep / this.perView));
          [...this.dots.children].forEach((dot, page) => {
            dot.setAttribute('aria-current', page === active ? 'true' : 'false');
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
